<ng-container *transloco="let t; read: 'homeOrga'" [appHelp]="['organizer']">

  <div class="linear-bg-color-on-bottom">
    <div class="page-container --no-margin-bottom">
      <div class="main-container">
        <div class="main-container__first-row">
          <div class="main-container__first-row__text-panel">
            <h1 class="title --home pt-4">
              {{ t('yourFanDontDeserve') }}<br>
              <p class="custom-event fw-700 typing --first">{{ t('speculation') }}</p>
              <p class="custom-event fw-700 typing --second">{{ t('fakeTickets') }}</p>
              <p class="custom-event fw-700 typing --third">{{ t('illegalResellers') }}</p>
            </h1>
            <p class="fragment-paragraph">
              {{ t('offerASolution') }} <span class="custom-event fw-700">{{ t('simple') }}</span> {{ t('and') }} <span class="custom-event fw-700">{{ t('secure') }}</span>
              {{ t('toYourVisitorWhoWantsToResale') }}
            </p>
            <div class="buttons-group --row">
              <a mat-button class="button --custom-event --small my-5 --full-width" [routerLink]="ROUTES.DEMO">
                {{ t('askForADemo') }}
              </a>
            </div>
          </div>
          <div class="main-container__first-row__imgs-panel">
            <img class="desktop-image" [src]="'assets/img/' + orgaExamples[selectedEventIndex]?.imgsUrl?.desktop" [alt]="orgaExamples[selectedEventIndex]?.name + ' desktop'">
            <img class="mobile-image" [src]="'assets/img/' + orgaExamples[selectedEventIndex]?.imgsUrl?.mobile" [alt]="orgaExamples[selectedEventIndex]?.name + ' mobile'">
          </div>
        </div>
        <div class="center mt-4">
          <img src="assets/img/flag-france.svg" class="french-flag">
          <p class="fragment-paragraph fw-600 py-3">
            {{ t('frenchFirst') }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="reelax-white-bg">
    <div id="partenaires" #partners>
      <app-all-organizers-carousel/>
    </div>
  </div>

  <div class="linear-bg-color-on-top pt-5" *appLet="(appService.settings.asObservable() | async) as setting">
    <div class="page-container py-5 --no-margin-bottom">
      <h2 class="fragment-title">
        {{ t('yourFans') }} <span class="custom-event fw-700">{{ t('deserve') }}</span> {{ t('all') }}
      </h2>

      <div class="fan-needs semi-card-bg-on-large" *appLet="(colorService.color | async) as color">
        <div class="fan-needs__item semi-card-bg-on-small">
          <div class="fan-needs__item__img">
            <object
              extra="origin"
              class="custom-color-svg"
              type="image/svg+xml"
              [data]="'assets/img/illustration/security.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              [ngClass]="{'--background-logo': color === colorService.defaultColor}"
              >
              <param name="color" [value]="color">
            </object>
            <object
              [ngClass]="{'--background-logo': color !== colorService.defaultColor}"
              type="image/svg+xml"
              [data]="'assets/img/illustration/security.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              >
              <param name="color" value="#242425">
            </object>
          </div>
          <div class="fan-needs__item__text">
            <h3 class="fan-needs__item__text__title">{{ t('validTickets') }}</h3>
            <p class="fan-needs__item__text__paragraph">
              {{ t('sellerTicketInvalidated') }}
              <span class="custom-event fw-700">{{ t('ticketWithHisName') }}</span>
              {{ t('withA') }}
              <span class="custom-event fw-700">{{ t('uniqueBarcode') }}</span>
              {{ t('orAGarantedAccess') }}
            </p>
          </div>
        </div>

        <div class="fan-needs__item">
          <div class="fan-needs__item__img">
            <object
              class="custom-color-svg"
              type="image/svg+xml"
              [data]="'assets/img/illustration/savings.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              [ngClass]="{'--background-logo': color === colorService.defaultColor}"
              >
              <param name="color" [value]="color">
            </object>
            <object
              [ngClass]="{'--background-logo': color !== colorService.defaultColor}"
              type="image/svg+xml"
              [data]="'assets/img/illustration/savings.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              >
              <param name="color" value="#242425">
            </object>
          </div>
          <div class="fan-needs__item__text">
            <h3 class="fan-needs__item__text__title">{{ t('fairPrice') }}</h3>
            <p class="fan-needs__item__text__paragraph">
              {{ t('yourFanCanResell') }}
              <span class="custom-event fw-700">{{ t('faceValue') }}</span>
              {{ t('inAFewClick') }}
              <span class="custom-event fw-700">{{ t('free') }}</span>.
            </p>
          </div>
        </div>

        <div class="fan-needs__item semi-card-bg-on-small">
          <div class="fan-needs__item__img">
            <object
              class="custom-color-svg"
              type="image/svg+xml"
              [data]="'assets/img/illustration/messaging.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              [ngClass]="{'--background-logo': color === colorService.defaultColor}"
              >
              <param name="color" [value]="color">
            </object>
            <object
              [ngClass]="{'--background-logo': color !== colorService.defaultColor}"
              type="image/svg+xml"
              [data]="'assets/img/illustration/messaging.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              >
              <param name="color" value="#242425">
            </object>
          </div>
          <div class="fan-needs__item__text">
            <h3 class="fan-needs__item__text__title">{{ t('essentialInformations') }}</h3>
            <p class="fan-needs__item__text__paragraph">
              <span class="custom-event fw-700">{{ t('communicateLastPurchaser') }}</span>
              {{ t('ticketAsNeverBeingSoSimple') }}
            </p>
          </div>
        </div>

        <div class="fan-needs__item">
          <div class="fan-needs__item__img">
            <object
              class="custom-color-svg"
              type="image/svg+xml"
              [data]="'assets/img/illustration/floating.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              [ngClass]="{'--background-logo': color === colorService.defaultColor}"
              >
              <param name="color" [value]="color">
            </object>
            <object
              [ngClass]="{'--background-logo': color !== colorService.defaultColor}"
              type="image/svg+xml"
              [data]="'assets/img/illustration/floating.svg' + (setting.referer ? '?wref=' + setting.referer : '') | safe:'resourceUrl'"
              >
              <param name="color" value="#242425">
            </object>
          </div>
          <div class="fan-needs__item__text">
            <h3 class="fan-needs__item__text__title">{{ t('aRefund') }}</h3>
            <p class="fan-needs__item__text__paragraph">
              {{ t('inCaseOfReport') }}
              <span class="custom-event fw-700">{{ t('refundAutomatically') }}</span>
              {{ t('lastTicketHolder') }}
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="linear-bg-color-on-bottom overflow-hidden pt-5">
    <div class="page-container py-5 --no-margin-bottom">
      <h2 class="fragment-title">
        {{ t('yourFanNeeds') }} <span class="custom-event fw-700"> {{ t('your') }} {{ t('ticketMarketplace') }}</span>
      </h2>
      <p class="fragment-paragraph">
        {{ t('yourTicketMarketplace') }} {{ t('adaptsTo') }}
        <span class="custom-event fw-700">{{ t('yourRequirements') }}</span>
        {{ t('and') }} {{ t('to') }}
        <span class="custom-event fw-700">{{ t('yourDesign') }}</span>
        {{ t('inNoTime') }}
      </p>
      <div class="custom-platforms">
        <div class="custom-platforms__imgs-panel">
          <div class="tooltip-demo platform-selection" [ngClass]="{'opposite': selectedEventIndex === 1}">
            <p class="fw-600 fs-14">
              {{ t('customizedYouSaid') }}
            </p>
            <p class="fw-400 fs-12">
              {{ t('clickOnTheMarketPlace') }}
            </p>
          </div>
          @for (orgaExample of orgaExamples; track orgaExample; let i = $index) {
            <img [class]="i === 0 ? 'foreground-example' : 'background-example'"
              [ngClass]="{'active': selectedEventIndex === i}"
              [src]="'assets/img/' + orgaExample?.imgsUrl?.desktop"
              [alt]="orgaExample?.name + ' desktop'"
              (click)="selectedEventIndex === i ? null : changeEvent()">
          }
        </div>
        <div class="custom-platforms__text-panel right-card-bg">
          <p class="fragment-paragraph custom-platforms__text-panel__item --first">
            {{ t('activateResale') }} <span class="custom-event fw-700">{{ t('soldOutCategories') }}</span>
          </p>
          <p class="fragment-paragraph custom-platforms__text-panel__item --second">
            {{ t('identifyThe') }} <span class="custom-event fw-700">{{ t('publicationDate') }}</span>
          </p>
          <p class="fragment-paragraph custom-platforms__text-panel__item --third">
            {{ t('defineA') }} <span class="custom-event fw-700">{{ t('minimalPrice') }}</span>
          </p>
          <p class="fragment-paragraph custom-platforms__text-panel__item italic --fourth">
            {{ t('andALotMore') }}
          </p>
          <p class="fragment-paragraph custom-platforms__text-panel__item italic --fifth">
            {{ t('inLessThan5min') }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="linear-bg-color-on-top py-5">
    <div class="page-container py-5 --no-margin-bottom">
      <h2 class="fragment-title">
        {{ t('yourFans') }}, <span class="custom-event fw-700">{{ t('yourData') }}</span>
      </h2>
      <p class="fragment-paragraph">
        {{ t('whenSoldOutSecondHandCanBeUpTo') }}
        <span class="custom-event fw-700">{{ t('20percentOfYourVisitor') }}</span>.
        <br>
        {{ t('waitlistCanEvenHold') }}
        <span class="custom-event fw-700">{{ t('moreThanA100') }}</span>
        {{ t('ofYourCapacity') }}
        <br>
        {{ t('dontMissOnThosePreciousData') }}
      </p>
      <div class="dashboard-orga">
        <div class="tooltip-demo dashboard-selection">
          <p class="fw-600 fs-14">
            {{ t('haveALookOfTheDashboard') }}
          </p>
          <p class="fw-400 fs-12">
            {{ t('clickOnTheTabs') }}
          </p>
        </div>
        <div class="dashboard-orga__buttons">
          @for (url of dashboardTab; track url; let i = $index) {
            @if (dashboardTab[i].clickable) {
              <a class="tab" [ngClass]="{'active': selectedDashboardIndex === i}" (click)="selectedDashboardIndex = i"></a>
            } @else {
              <div class="tab --blank"></div>
            }
          }
        </div>
        <div class="dashboard-orga__img">
          <img [src]="'assets/img/' + dashboardTab[selectedDashboardIndex].url" loading="lazy"
            alt="Tableau de bord organisateur - Reelax Tickets">
        </div>
      </div>
      <div class="buttons-group small-container">
        <a mat-button class="button --full-width --custom-event --small my-5" [routerLink]="ROUTES.DEMO">
          {{ t('askForADemo') }}
        </a>
      </div>
    </div>
  </div>

  <div class="linear-bg-color-on-top">
    <div class="partners-section">
      <div class="page-container --no-margin-bottom">
        <div class="partners">
          <div class="partners__imgs-panel">
            <div class="rounded-logo --reelax-tickets">
              <img src="assets/img/reelax-arrows.svg?v=1" alt="reelax tickets">
            </div>
            @for (company of companies; track company; let i = $index) {
              <a [href]="company.website" target="_blank">
                <div [class]="'rounded-logo --' + company.name">
                  <img [src]="'assets/img/' + company.logo"
                    [alt]="company.name" [matTooltip]="company.name">
                </div>
              </a>
            }
          </div>
          <div class="partners__text-panel my-auto py-5">
            <h2 class="fragment-title p-0">
              {{ t('weAreAlreadyInsideYourFavoriteSoftware') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="linear-bg-color-on-bottom pt-5" *transloco="let tfaq; read: 'faq.home-orga'">
    <div class="page-container py-5 --no-margin-bottom">
      <h2 class="fragment-title">
        {{ t('mostFrequentlyAskedQuestions--begin') }}
        <span class="custom-event fw-700">{{ t('mostFrequentlyAskedQuestions--colored') }}</span>
        {{ t('mostFrequentlyAskedQuestions--end') }}
      </h2>

      <div class="faq-orga">
        @for (faqItem of ['organisateur_logiciel-compatible', 'organisateur_cout', 'organisateur_temps-installation', 'organisateur_logiciel-data']; track faqItem) {
          <div class="faq-orga__item">
            <h3 class="faq-orga__item__question">{{ tfaq(faqItem + '.question') }}</h3>
            <p class="faq-orga__item__answer" [innerHTML]="tfaq(faqItem + '.answer')"></p>
          </div>
        }

        <div class="buttons-group --row small-container pb-5">
          <a mat-button class="button --full-width --custom-event --small" [routerLink]="ROUTES.FAQ.ORGA">
            {{ t('seeFAQ') }}
          </a>
        </div>
      </div>

      <mat-card class="orga-card my-5">
        <p class="orga-card__text-panel">
          {{ t('together') }}, <span class="custom-event fw-700">{{ t('fightBlackMarket') }}</span>
          {{ t('protectTheFans') }}
        </p>
        <div class="buttons-group --row mb-0">
          <a mat-button class="button --full-width --custom-event --small my-5" [routerLink]="ROUTES.DEMO">
            {{ t('askForADemo') }}
          </a>
        </div>
      </mat-card>
    </div>
  </div>

  <div class="linear-bg-color-on-top">
    <div class="page-container py-5 --no-margin-bottom">
      <h2 class="fragment-title">
        {{ t('newsletter') }}
      </h2>

      <p class="fragment-paragraph mb-4">
        {{ t('registerToTheNewsletter') }}
        <span class="custom-event fw-700">{{ t('latestNews') }}</span>
        {{ t('onTheTopic') }} <span class="custom-event fw-700">{{ t('resale') }}</span>.
      </p>

      <app-newsletter-form/>

    </div>
  </div>

</ng-container>